/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'getCustomerAncestorRunnerLimitsBySystemGameTypeId',
    message: messages.SUCCESS_GET_CUSTOMER_ANCESTOR_RUNNER_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'GET',
    path: '/customer/:customerId/ancestor-runner-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_ANCESTOR_RUNNER_LIMIT,
    requestSchema: requestSchemas.customers.getCustomerAncestorRunnerLimitsBySystemGameTypeId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'getCustomerById',
    message: messages.SUCCESS_GET_CUSTOMER_BY_ID,
    method: 'GET',
    path: '/customer/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_CUSTOMER,
    requestSchema: requestSchemas.customers.getCustomerById,
  },
  {
    action: 'getCustomerRelationshipsBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_RELATIONSHIPS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/relationships/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_RELATIONSHIP,
    requestSchema: requestSchemas.customers.getCustomerRelationshipsBySystemGameId,
    scopes: [
      scopes.CUSTOMER_RELATIONSHIPS_ANCESTOR_BY_SYSTEM_GAME_ID,
      scopes.CUSTOMER_RELATIONSHIPS_INPUT_BY_SYSTEM_GAME_ID,
      scopes.DEFAULT,
    ],
  },
  {
    action: 'updateCustomerById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_BY_ID,
    method: 'PATCH',
    path: '/customer/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER,
    requestSchema: requestSchemas.customers.updateCustomerById,
  },
];
